export const NOT_AVAILABLE = 'Not_Available'
export const SUKI = 'Suki'
export const HELP = 'Help'
export const HELP_TITLE = 'Find answers.'
export const HELP_DESC1 = 'Check out the Suki Help Center for'
export const HELP_DESC2 = 'FAQs & tutorials.'
export const VIDEO = 'Video'
export const VIDEO_TITLE = 'See an example.'
export const VIDEO_DESC = 'Watch how Suki can help you create notes.'
export const CHAT = 'Chat'
export const CHAT_TITLE = 'Or chat with us.'
export const CHAT_DESC = 'Message us if you cant find what you need above.'
export const STATUS_TITLE = 'Service Status'
